FechaIniPrevistaDialogCtrl.$inject = ['$log', '$scope', '$http'];
export default function FechaIniPrevistaDialogCtrl($log, $scope, $http) {
    const id = $scope.model.id;

    const vm = this;

    const urlBase = Sigo.var.path + '/api/v2/tareas/' + id + '/obtener';

    vm.cargando = true;
    vm.tarea = null;

    $scope.model.fecha = null;
    $scope.model.minutos = 0;
    vm.model = $scope.model;

    cargarTarea();

    function cargarTarea() {
        $http.get(urlBase)
            .then((respuesta) => {
                vm.tarea = respuesta.data;
                if (!vm.tarea.fechaInicioPrevista) vm.model.fecha = moment().format("YYYY-MM-DD HH:mm");
                else vm.model.fecha = vm.tarea.fechaInicioPrevista.substring(0, 16);
            })
            .catch(() => $log.error('Error'))
            .finally(() => vm.cargando = false);
    }
}